export default {
  quoteExternalLink: null // this is object
}



// WEBPACK FOOTER //
// ./src/modules/library/store/state.js